const material_gold = "378";
function isValidPrice(price: string | number): boolean {
    return Number(price) > 0;
}

function isDateInRange(date: Date, dateRange: { _date_from: string, _date_to: string }): boolean {
 if (dateRange._date_from && dateRange._date_to) {
  let fromDateStr = dateRange._date_from;
  let toDateStr = dateRange._date_to;
  if (!fromDateStr.includes('00:00:00')) {
      fromDateStr += ' 00:00:00';
    }
if (!toDateStr.includes('23:59:59')) {
      toDateStr += ' 23:59:59';
    }
    const fromDate = new Date(`${fromDateStr} `);
    const toDate = new Date(`${toDateStr}`);
    return date >= fromDate && date <= toDate;
 } else return false;
}


function isDateInRangeSale(date: Date, dateRange: { _date_from: string, _date_to: string }): boolean {
if (dateRange._date_from == '' && dateRange._date_to == '') return true;
///console.log('-- date',date,dateRange)

let fromDateStr = dateRange._date_from;
  let toDateStr = dateRange._date_to;
  if (!fromDateStr.includes('00:00:00')) {
      fromDateStr += ' 00:00:00';
    }
if (!toDateStr.includes('23:59:59')) {
      toDateStr += ' 23:59:59';
    }

// if (!dateRange._date_from) dateRange._date_from = '00:00:00';
// if (!dateRange._date_to) dateRange._date_to = '23:59:59';
    if (fromDateStr && toDateStr) {
        const fromDate = new Date(`${fromDateStr} `);
        const toDate = new Date(`${toDateStr} `);
        if (date < fromDate) return false;
         if (date > toDate) return false;
    } 
    return true;
}



const getPriceDataCustomise = (data) => {
//console.log('---- data',data);
  if (!data) {
    return {
      regular_price: null,
      sale_price: null,
      price: 0
    };
  }

  const {
    regular_price = null,
    short_term_price = null,
    short_term_dates = {},
    sale_price = null,
    sale_price_dates = {}
  } = data;

  let priceDataCustomise = {
    regular_price: regular_price ?? '',
    sale_price: '',
    price: regular_price ?? 0
  };

  const dateCurrent = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Asia/Singapore' })
  );

  const setPriceData = (price:string) => {
    priceDataCustomise.sale_price = price;
    priceDataCustomise.price = price;
  };

  const { _date_from: shortTermDateFrom = '', _date_to: shortTermDateTo = '' } = short_term_dates || {};
  const { _date_from: saleDateFrom = '', _date_to: saleDateTo = '' } = sale_price_dates || {};


  if (
    short_term_price !== null &&
    isValidPrice(short_term_price) &&
    isDateInRange(dateCurrent, { _date_from: shortTermDateFrom, _date_to: shortTermDateTo })
  ) {
    setPriceData(short_term_price);
    return priceDataCustomise;
  }

  //console.log('---- dateCurrent',dateCurrent,saleDateFrom,saleDateTo)
  //console.log('---- saleDateFrom',saleDateFrom)
  //console.log('---- saleDateTo',saleDateTo)
  //console.log('-- ',isDateInRangeSale(dateCurrent, { _date_from: saleDateFrom, _date_to: saleDateTo }))

  if (
    sale_price !== null &&
    isValidPrice(sale_price) &&
    isDateInRangeSale(dateCurrent, { _date_from: saleDateFrom, _date_to: saleDateTo })
  ) {
    setPriceData(sale_price);
    return priceDataCustomise;
  }

  priceDataCustomise.sale_price = '';
  return priceDataCustomise;
};

type CustomiseTopupOptions = Record<string, Record<string, string | number>> | Array<Record<string, string | number>>;

function calculateCustomiseTopup(termIDs: string, topupOptions: CustomiseTopupOptions): number {
  const selectedTermIDs = (termIDs || '').split(',');

  return Object.values(topupOptions || {})
    .flatMap(options => Object.entries(options))
    .filter(([termID]) => selectedTermIDs.includes(termID))
    .reduce((sum, [, value]) => sum + Number(value), 0);
}

 function calculatorPriceCustomise2(
  currentPriceData: {
    gemstone_price: number;
    material_data: {
      material_rate: number | string;
      weight: number;
    };
    workmanship: {
      regular: string;
      sale: string;
      short_term: string;
    };
  },
   termIDs: string,
    //topup: number,
    toupOption: CustomiseTopupOptions,
 materialPriceData: Record<string, string>,
  materialMultiplierData: Record<string, number>
) {
if (!currentPriceData) {
    return {
      "regular_price": 0,
      "sale_price": '',
      "short_term_price": '',
    };
  }
  // Extract values from currentPriceData
  const gemstone_price = currentPriceData.gemstone_price || 0;
  const topup = calculateCustomiseTopup(termIDs, toupOption);


  
  const material_data = currentPriceData.material_data || {};
  const weight = material_data.weight || 0;
  const rateKey = material_data.material_rate ? String(material_data.material_rate) : 'default'; // Convert to string for comparison
  //console.log('----- rateKey: ',rateKey)
  //console.log('--- materialPriceData',materialPriceData)
  
  const rateKeyStr:string = String(rateKey);

const rateMaterial = parseFloat(
    materialPriceData[rateKeyStr] ?? materialPriceData['default'] ?? '0'
);

  // Get multiplier from materialMultiplierData
  let multiplier = 1;
  if (rateKey && materialMultiplierData[rateKey] !== undefined) {
    multiplier = materialMultiplierData[rateKey];
  }

  // Calculate material price
  const materialPrice = multiplier * rateMaterial * weight;

  // Extract workmanship values
   const workmanship = currentPriceData.workmanship || {};
  const workmanship_regular = workmanship.regular || "0";
  const workmanship_sale = workmanship.sale || "0";
  const workmanship_shortterm = workmanship.short_term || "0";

  // Calculate base price
  const basePrice = Number(materialPrice) + Number(topup) + Number(gemstone_price);

    const regularPrice = Math.ceil((Math.floor(basePrice + Number(workmanship_regular))) / 10) * 10 - 1;
  // Return price object
  const a =  {
    "regular_price": regularPrice > 0 ? regularPrice : '',
    "sale_price": regularPrice > 0 && parseFloat(workmanship_sale) > 0 ? Math.ceil((Math.floor(basePrice + Number(workmanship_sale))) / 10) * 10 - 1 : '',
    "short_term_price": regularPrice > 0 && parseFloat(workmanship_shortterm) > 0 ? Math.ceil((Math.floor(basePrice + Number(workmanship_shortterm))) / 10) * 10 - 1 : '',
    }
  return a;

}

function calculatorPriceCustomiseMultiNameNecklace(
  currentPriceData: {
    gemstone_price: number;
    material_data: {
      material_rate: number | string;
      weight: number;
    };
    workmanship: {
      regular: string;
      sale: string;
      short_term: string;
    };
    workmanship_product_data?: {
      workmanship_fee?: Record<string, string | number>;
      workmanship_fee_sale?: Record<string, string | number>;
      workmanship_fee_shorterm?: Record<string, string | number>;
    };
  },
  termIDs: string,
  toupOption: CustomiseTopupOptions,
  materialPriceData: Record<string, string>,
  materialMultiplierData: Record<string, number>,
  charsWeight: Record<string, Record<string, number>>,
  multiNameValue: Record<string, string>,
) {
console.log('--currentPriceDatannnnn: ',currentPriceData)
if (!currentPriceData) {
  console.log('?????????');
    return {
      "regular_price": 0,
      "sale_price": '',
      "short_term_price": '',
    };
  }
  // Extract values from currentPriceData
  const gemstone_price = currentPriceData.gemstone_price || 0;
  const topup = calculateCustomiseTopup(termIDs, toupOption);
  
    const material_data = currentPriceData.material_data || {};
    const weight = material_data.weight || 0;
   const rateKey = material_data.material_rate ? String(material_data.material_rate) : "378"; // Convert to st ring for comparison
  
  const rateMaterial = parseFloat(
    materialPriceData[rateKey] ?? materialPriceData['default'] ?? '0'
  );

  console.log(rateKey,multiNameValue,charsWeight,materialPriceData,materialMultiplierData);
  
  // Get multiplier from materialMultiplierData
  let multiplier = 1;
  if (rateKey && materialMultiplierData[rateKey] !== undefined) {
    multiplier = materialMultiplierData[rateKey];
  }

  let lengthName = Math.max(
    1,
    Object.values(multiNameValue || {}).reduce(
      (total, value) => total + value.length,
      0
    )
  );
  const charsWeightByMaterial = charsWeight?.[rateKey];
  const weightRanges = Object.entries(charsWeightByMaterial || {});
  let totalWeight = Number(weight);

  if (weightRanges.length > 0) {
    const maxLength = Math.max(...weightRanges.map(([range]) => Number(range.split('-')[1])));
    lengthName = Math.min(lengthName, maxLength);
    const matchedRange = weightRanges.find(([range]) => {
      const [min, max] = range.split('-').map(Number);
      return lengthName >= min && lengthName <= max;
    });

    if (matchedRange) {
      totalWeight = Number(matchedRange[1]);
    }
  }

  const materialPrice = multiplier * rateMaterial * totalWeight;
  // Extract workmanship values
   const workmanship = currentPriceData.workmanship || {};
 let workmanship_regular = workmanship.regular || "0";
let workmanship_sale = workmanship.sale || "0";
let workmanship_shortterm = workmanship.short_term || "0";

  const workmanship_product_data =
    currentPriceData.workmanship_product_data || {};

  const workmanship_fee =
    workmanship_product_data.workmanship_fee || {};

  const workmanship_fee_sale =
    workmanship_product_data.workmanship_fee_sale || {};

  const workmanship_fee_shorterm =
    workmanship_product_data.workmanship_fee_shorterm || {};

  // Find the range that matches lengthName.
  const findWorkmanshipFee = (feeData: Record<string, string | number>, fallback: string): string => {
    for (const [range, fee] of Object.entries(feeData)) {

      const [min, max] = range.split('-').map(Number);

      if (lengthName >= min && lengthName <= max) {
        return String(fee);
      }
    }

    return fallback;
  };
   console.log('-- workmanship_fee: ',workmanship_product_data,workmanship_fee,workmanship_regular);
  workmanship_regular = findWorkmanshipFee(workmanship_fee, workmanship_regular);
  workmanship_sale = findWorkmanshipFee(workmanship_fee_sale, workmanship_sale);
  workmanship_shortterm = findWorkmanshipFee(workmanship_fee_shorterm, workmanship_shortterm);
   console.log('-- workmanship_regular: ',workmanship_regular);

  // Calculate base price
  const basePrice = Number(materialPrice) + Number(topup) + Number(gemstone_price);

    const regularPrice = Math.ceil((Math.floor(basePrice + Number(workmanship_regular))) / 10) * 10 - 1;
  // Return price object
  const a =  {
    "regular_price": regularPrice > 0 ? regularPrice : '',
    "sale_price": regularPrice > 0 && parseFloat(workmanship_sale) > 0 ? Math.ceil((Math.floor(basePrice + Number(workmanship_sale))) / 10) * 10 - 1 : '',
    "short_term_price": regularPrice > 0 && parseFloat(workmanship_shortterm) > 0 ? Math.ceil((Math.floor(basePrice + Number(workmanship_shortterm))) / 10) * 10 - 1 : '',
    }
    console.log('-price multi: ',a);
  return a;

}


//export default getPriceDataCustomise ;

export {
    getPriceDataCustomise,
  calculatorPriceCustomise2,
  calculatorPriceCustomiseMultiNameNecklace
}
